import { render, staticRenderFns } from "./MobileDashboard.vue?vue&type=template&id=2308522e&scoped=true&"
import script from "./MobileDashboard.vue?vue&type=script&lang=ts&"
export * from "./MobileDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2308522e",
  null
  
)

export default component.exports